<template>
  <div ref="root">
  <!-- Hero section -->
  <section class="bg-[var(--surface-raised)] mt-[3.9rem] md:mt-14">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-6 lg:gap-12">

      <!-- Logo -->
      <svg class="h-auto w-24 sm:w-auto max-w-[114px] text-[var(--text-primary)]" width="257" height="86" viewBox="0 0 257 86" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Amazon logo" role="img">
        <g clip-path="url(#clip0_3312_32772)">
          <mask id="mask0_3312_32772" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="257" height="46">
            <path d="M0 0H257V45.6175H0V0Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_3312_32772)">
            <path d="M222.088 2.31139C222.088 1.92627 222.211 1.61092 222.457 1.36604C222.737 1.08558 223.07 0.945691 223.455 0.945691H230.396C230.781 0.945691 231.097 1.06813 231.342 1.31336C231.622 1.55859 231.798 1.89138 231.868 2.31139L232.919 7.45984H233.34C234.287 5.07834 235.671 3.23963 237.494 1.94371C239.351 0.64779 241.525 0 244.013 0C246.677 0 248.973 0.700461 250.901 2.10138C252.864 3.50231 254.371 5.49869 255.423 8.09019C256.474 10.682 257 13.7466 257 17.2837V43.2884C257 43.6738 256.86 44.0066 256.579 44.2867C256.334 44.532 256.019 44.6544 255.633 44.6544H247.22C246.835 44.6544 246.502 44.532 246.222 44.2867C245.976 44.0066 245.854 43.6738 245.854 43.2884V18.1244C245.854 15.5678 245.328 13.6063 244.276 12.2406C243.225 10.8746 241.735 10.1916 239.807 10.1916C237.669 10.1916 236.039 10.9974 234.917 12.6083C233.796 14.2192 233.235 16.5484 233.235 19.5955V43.2884C233.235 43.6738 233.095 44.0066 232.814 44.2867C232.569 44.532 232.253 44.6544 231.868 44.6544H223.455C223.07 44.6544 222.737 44.532 222.457 44.2867C222.211 44.0066 222.088 43.6738 222.088 43.2884V2.31139ZM190.016 22.7999C190.016 27.2479 190.647 30.6801 191.909 33.0968C193.17 35.4783 194.993 36.6692 197.377 36.6692C199.76 36.6692 201.601 35.4783 202.897 33.0968C204.194 30.6801 204.843 27.2479 204.843 22.7999C204.843 18.3522 204.194 14.9375 202.897 12.5556C201.601 10.1392 199.76 8.93088 197.377 8.93088C194.993 8.93088 193.17 10.1392 191.909 12.5556C190.647 14.9375 190.016 18.3522 190.016 22.7999ZM178.449 22.7999C178.449 18.5273 179.273 14.657 180.92 11.1899C182.567 7.68763 184.828 4.9559 187.703 2.9944C190.612 0.99802 193.837 0 197.377 0C200.952 0 204.177 0.99802 207.051 2.9944C209.96 4.9559 212.239 7.68763 213.886 11.1899C215.569 14.657 216.41 18.5273 216.41 22.7999C216.41 27.0728 215.569 30.9605 213.886 34.4628C212.239 37.9299 209.96 40.6616 207.051 42.658C204.177 44.6195 200.952 45.6001 197.377 45.6001C193.837 45.6001 190.612 44.6195 187.703 42.658C184.828 40.6616 182.567 37.9299 180.92 34.4628C179.273 30.9605 178.449 27.0728 178.449 22.7999ZM144.484 36.9319C144.484 36.1613 144.694 35.4957 145.115 34.9355L163.096 9.77157H146.271C145.886 9.77157 145.553 9.64878 145.272 9.40355C145.027 9.12344 144.904 8.79065 144.904 8.40553V2.31139C144.904 1.92627 145.027 1.61092 145.272 1.36604C145.553 1.08558 145.886 0.945691 146.271 0.945691H173.927C174.313 0.945691 174.628 1.08558 174.874 1.36604C175.154 1.61092 175.294 1.92627 175.294 2.31139V8.66821C175.294 9.43878 175.084 10.104 174.663 10.6646L158.364 33.0441C159.345 32.869 160.345 32.7814 161.361 32.7814C163.885 32.7814 166.198 33.0092 168.301 33.4645C170.439 33.8848 172.648 34.5853 174.926 35.5658C175.732 35.9161 176.135 36.5115 176.135 37.3522V43.3937C176.135 43.9539 175.96 44.3391 175.61 44.5494C175.259 44.7245 174.821 44.7071 174.295 44.4967C171.666 43.5162 169.335 42.8331 167.302 42.448C165.304 42.0277 163.114 41.8177 160.73 41.8177C158.382 41.8177 156.068 42.0277 153.79 42.448C151.546 42.8684 149.058 43.551 146.324 44.4967C145.798 44.6718 145.36 44.6718 145.009 44.4967C144.659 44.2867 144.484 43.9191 144.484 43.3937V36.9319ZM115.566 31.2054C115.566 33.0619 116.039 34.5504 116.985 35.6708C117.967 36.7568 119.281 37.2996 120.929 37.2996C123.102 37.2996 124.767 36.3364 125.924 34.4102C127.08 32.449 127.659 29.6472 127.659 26.0046V23.2202C126.677 23.0451 125.748 22.9575 124.872 22.9575C121.998 22.9575 119.719 23.7107 118.037 25.2166C116.39 26.6876 115.566 28.684 115.566 31.2054ZM104.104 32.4664C104.104 29.3493 104.875 26.6175 106.417 24.2709C107.995 21.9243 110.221 20.1208 113.095 18.8598C116.004 17.5991 119.404 16.9687 123.295 16.9687C125.082 16.9687 126.537 17.0912 127.659 17.3364V16.2331C127.659 13.5714 127.168 11.5925 126.187 10.2969C125.205 8.96577 123.715 8.30053 121.717 8.30053C118.493 8.30053 116.425 9.99902 115.513 13.3963C115.233 14.3769 114.654 14.7972 113.778 14.657L106.628 13.3963C106.102 13.2913 105.734 13.0635 105.523 12.7133C105.348 12.3631 105.331 11.8904 105.471 11.2949C106.382 7.72252 108.31 4.9559 111.255 2.9944C114.234 0.99802 117.967 0 122.453 0C127.781 0 131.83 1.43581 134.599 4.30777C137.403 7.17973 138.805 11.3651 138.805 16.8637V43.2884C138.805 43.6738 138.665 44.0066 138.385 44.2867C138.139 44.532 137.824 44.6544 137.438 44.6544H130.603C129.762 44.6544 129.236 44.1992 129.026 43.2884L127.974 38.3503H127.554C126.607 40.6616 125.188 42.448 123.295 43.7087C121.437 44.9697 119.229 45.6001 116.67 45.6001C114.181 45.6001 111.991 45.0573 110.098 43.9714C108.205 42.8506 106.733 41.3098 105.681 39.3483C104.63 37.3522 104.104 35.0579 104.104 32.4664ZM41.2208 2.31139C41.2208 1.92627 41.3437 1.61092 41.5891 1.36604C41.8695 1.08558 42.2025 0.945691 42.588 0.945691H49.5282C49.9139 0.945691 50.2292 1.06813 50.4746 1.31336C50.755 1.55859 50.9302 1.89138 51.0004 2.31139L52.052 7.45984H52.4727C53.4191 5.04346 54.7685 3.20475 56.5211 1.94371C58.3086 0.64779 60.4117 0 62.8304 0C65.4244 0 67.65 0.683018 69.5077 2.04871C71.4006 3.41475 72.8551 5.35846 73.8717 7.88019H74.2924C75.8345 5.21857 77.5696 3.23963 79.4975 1.94371C81.4253 0.64779 83.5811 0 85.9646 0C88.5586 0 90.8017 0.700461 92.6946 2.10138C94.6225 3.50231 96.0947 5.49869 97.111 8.09019C98.1277 10.682 98.636 13.7466 98.636 17.2837V43.2884C98.636 43.6738 98.4956 44.0066 98.2153 44.2867C97.9699 44.532 97.6543 44.6544 97.2688 44.6544H88.8564C88.4709 44.6544 88.1379 44.532 87.8575 44.2867C87.6121 44.0066 87.4892 43.6738 87.4892 43.2884V18.1244C87.4892 15.5678 86.9987 13.6063 86.0173 12.2406C85.0356 10.8746 83.6161 10.1916 81.7584 10.1916C79.7254 10.1916 78.1656 10.9974 77.0791 12.6083C76.0275 14.2192 75.5018 16.5484 75.5018 19.5955V43.2884C75.5018 43.6738 75.3614 44.0066 75.0811 44.2867C74.8356 44.532 74.52 44.6544 74.1346 44.6544H65.7222C65.3367 44.6544 65.0037 44.532 64.7233 44.2867C64.4779 44.0066 64.355 43.6738 64.355 43.2884V18.1244C64.355 15.5678 63.8645 13.6063 62.8831 12.2406C61.9014 10.8746 60.4819 10.1916 58.6242 10.1916C56.5912 10.1916 55.0314 10.9974 53.9449 12.6083C52.8933 14.2192 52.3676 16.5484 52.3676 19.5955V43.2884C52.3676 43.6738 52.2272 44.0066 51.9469 44.2867C51.7014 44.532 51.3858 44.6544 51.0004 44.6544H42.588C42.2025 44.6544 41.8695 44.532 41.5891 44.2867C41.3437 44.0066 41.2208 43.6738 41.2208 43.2884V2.31139ZM11.462 31.2054C11.462 33.0619 11.9351 34.5504 12.8815 35.6708C13.8629 36.7568 15.1774 37.2996 16.8249 37.2996C18.9982 37.2996 20.6631 36.3364 21.8198 34.4102C22.9764 32.449 23.5549 29.6472 23.5549 26.0046V23.2202C22.5735 23.0451 21.6445 22.9575 20.7682 22.9575C17.8939 22.9575 15.6155 23.7107 13.9331 25.2166C12.2856 26.6876 11.462 28.684 11.462 31.2054ZM12.5659 45.6001C10.0774 45.6001 7.88666 45.0573 5.99373 43.9714C4.10113 42.8506 2.62889 41.3098 1.57733 39.3483C0.525777 37.3522 0 35.0579 0 32.4664C0 29.3493 0.771209 26.6175 2.31328 24.2709C3.89062 21.9243 6.11661 20.1208 8.99093 18.8598C11.9002 17.5991 15.3003 16.9687 19.1909 16.9687C20.9784 16.9687 22.4332 17.0912 23.5549 17.3364V16.2331C23.5549 13.5714 23.064 11.5925 22.0826 10.2969C21.1013 8.96577 19.6116 8.30053 17.6135 8.30053C14.3887 8.30053 12.3209 9.99902 11.4093 13.3963C11.129 14.3769 10.5505 14.7972 9.67417 14.657L2.5238 13.3963C1.99802 13.2913 1.63005 13.0635 1.41953 12.7133C1.24427 12.3631 1.22681 11.8904 1.36716 11.2949C2.27837 7.72252 4.20622 4.9559 7.15071 2.9944C10.1301 0.99802 13.8629 0 18.3495 0C23.6774 0 27.7259 1.43581 30.4951 4.30777C33.2992 7.17973 34.7013 11.3651 34.7013 16.8637V43.2884C34.7013 43.6738 34.561 44.0066 34.2806 44.2867C34.0352 44.532 33.7199 44.6544 33.3341 44.6544H26.499C25.658 44.6544 25.1322 44.1992 24.9217 43.2884L23.8702 38.3503H23.4498C22.5033 40.6616 21.0838 42.448 19.1909 43.7087C17.3332 44.9697 15.125 45.6001 12.5659 45.6001Z" fill="currentColor"/>
          </g>
          <mask id="mask1_3312_32772" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="28" y="50" width="131" height="36">
            <path d="M28.5664 50.3457H158.609V86.0001H28.5664V50.3457Z" fill="white"/>
          </mask>
          <g mask="url(#mask1_3312_32772)">
            <path d="M29.2321 50.6979C28.5664 51.2233 28.426 52.0988 28.8118 53.3246C29.1623 54.4102 29.9859 55.7585 31.2829 57.3697C36.5054 63.8138 42.7271 69.1726 49.948 73.4451C57.1685 77.718 64.8974 80.8701 73.1346 82.9013C81.407 84.9678 89.8543 86.0011 98.4773 86.0011C109.519 86.0011 120.034 84.3898 130.024 81.168C140.014 77.9807 148.356 73.4978 155.051 67.719C157.399 65.6525 158.574 64.0067 158.574 62.7809C158.574 62.3253 158.381 61.8701 157.995 61.4148C157.469 60.8895 156.839 60.7144 156.102 60.8895C155.366 61.0646 154.332 61.5024 153 62.2029C146.586 65.5649 138.769 68.2443 129.551 70.2407C120.367 72.272 110.78 73.2878 100.791 73.2878C88.4174 73.2878 76.4645 71.6064 64.9326 68.2443C53.4004 64.8823 43.183 59.6288 34.2797 52.484C32.9828 51.4682 31.9312 50.8204 31.1251 50.5402C30.3539 50.2601 29.723 50.3125 29.2321 50.6979Z" fill="currentColor"/>
          </g>
          <path d="M146.061 53.3232C145.324 54.0237 145.132 54.759 145.482 55.5296C145.728 56.0899 146.201 56.4052 146.902 56.4753C147.603 56.5803 148.602 56.5102 149.899 56.265C152.002 55.8097 154.193 55.4944 156.471 55.3193C158.749 55.1794 160.73 55.2143 162.412 55.4246C164.095 55.6695 165.146 56.0899 165.567 56.6853C166.198 57.631 165.97 59.6274 164.884 62.6741C163.832 65.7212 162.395 68.6807 160.572 71.5527C159.871 72.7084 159.45 73.6188 159.31 74.2844C159.17 74.95 159.345 75.5102 159.836 75.9654C160.152 76.2808 160.502 76.4385 160.887 76.4385C161.904 76.4385 163.376 75.5451 165.304 73.7591C168.774 70.7472 171.21 67.1748 172.612 63.0421C173.384 60.9055 173.857 58.6643 174.032 56.3176C174.207 53.971 173.944 52.29 173.243 51.2742C172.577 50.2936 171.105 49.4881 168.827 48.8578C166.583 48.2271 164.322 47.9121 162.044 47.9121C157.592 47.9121 153.369 48.9628 149.373 51.0642C147.901 51.8696 146.797 52.6228 146.061 53.3232Z" fill="currentColor"/>
        </g>
        <defs>
          <clipPath id="clip0_3312_32772">
            <rect width="257" height="86" fill="white"/>
          </clipPath>
        </defs>
      </svg>

      <!-- Title + Subtitle -->
      <div class="flex flex-col lg:flex-row items-start justify-between gap-8">
        <div class="lg:w-1/2">
          <h1 class="font-switzer text-4xl sm:text-5xl font-bold leading-tight tracking-tight text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.title') }}
          </h1>
        </div>
        <div class="lg:w-1/2">
          <p class="font-switzer text-xl lg:text-2xl font-medium leading-tight text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.title_description') }}
          </p>
        </div>
      </div>

      <!-- Tags + Team data -->
      <div class="flex flex-col lg:flex-row items-start justify-between gap-6">

        <!-- Tags -->
        <div class="lg:w-1/2 flex flex-wrap gap-4">
          <span
            v-for="(tag, idx) in $tm('caseStudies.CS_TA.tags')" :key="idx"
            class="inline-flex items-center justify-center px-3 py-1.5 border-[1.5px] border-[var(--color-neutral-300)] dark:border-[var(--color-neutral-600)] rounded-lg text-base font-medium text-[var(--text-secondary)]">
            {{ tag }}
          </span>
        </div>

        <!-- Team metadata -->
        <div class="lg:w-1/2 flex flex-wrap gap-x-16 gap-y-4">
          <!-- My role -->
          <div class="flex flex-col leading-relaxed">
            <span class="text-sm text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">{{ $t('caseStudies.CS_TA.myRole.title') }}</span>
            <span class="text-base text-[var(--text-primary)]">{{ $t('caseStudies.CS_TA.myRole.description') }}</span>
          </div>
          <!-- Team -->
          <div class="flex flex-col leading-relaxed">
            <span class="text-sm text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">{{ $tm('caseStudies.CS_TA.myTeam')[0]?.title }}</span>
            <p v-for="(member, idx) in $tm('caseStudies.CS_TA.myTeam')" :key="idx" class="text-base text-[var(--text-primary)] leading-relaxed m-0">{{ member.description }}</p>
          </div>
          <!-- Period -->
          <div class="flex flex-col leading-relaxed" v-if="$tm('caseStudies.CS_TA.timelines').length">
            <span class="text-sm text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">{{ $tm('caseStudies.CS_TA.timelines')[0].title }}</span>
            <span class="text-base text-[var(--text-primary)]">{{ $tm('caseStudies.CS_TA.timelines')[0].description }}</span>
          </div>
        </div>

      </div>
    </div>
  </section>
  <!-- End of Hero section -->

  <!-- Hero Graphic section -->
  <section class="bg-[var(--surface-elevated)] overflow-hidden">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pt-4 sm:pt-16">
      <img
        :src="heroScreenSrc"
        alt="Talent Alchemy product screen"
        class="w-full object-contain"
      />
    </div>
  </section>
  <!-- End of Hero Graphic section -->

  <!-- Impact overview section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-10">

      <h3 class="text-xl font-medium leading-snug text-[var(--text-secondary)]">
        {{ $t('caseStudies.CS_TA.impact-overview-section.title') }}
      </h3>

      <div class="grid grid-cols-2 gap-x-8 gap-y-10 lg:flex lg:justify-between">
        <div
          v-for="(stat, idx) in $tm('caseStudies.CS_TA.impact-overview-section.stats')"
          :key="idx"
          class="flex flex-col max-w-[230px]"
        >
          <span class="font-switzer text-3xl sm:text-4xl font-bold leading-snug tracking-[-0.9px] text-[var(--text-primary)]">{{ stat.value }}</span>
          <span class="font-switzer text-lg sm:text-2xl font-medium leading-snug text-[var(--text-secondary)]">{{ stat.label }}</span>
        </div>
      </div>

    </div>
  </section>
  <!-- End of Impact overview section -->

  <!-- Overview section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pb-16 lg:pb-24 flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

      <!-- Content -->
      <div class="flex flex-col gap-6 flex-1">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.overview-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.overview-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.overview-section.content') }}
        </p>
      </div>

      <!-- Logo -->
      <div class="shrink-0 flex items-center justify-center">
        <img :src="taLogoInkSrc" alt="Talent Alchemy logo" class="w-[140px] dark:hidden" />
        <img :src="taLogoWhiteSrc" alt="Talent Alchemy logo" class="w-[140px] hidden dark:block" />
      </div>

    </div>
  </section>
  <!-- End of Overview section -->

  <!-- Problem Statement section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pb-16 lg:pb-24 flex flex-col lg:flex-row items-start gap-12 lg:gap-16">

      <!-- Content -->
      <div class="flex flex-col gap-6 flex-1">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.problem-statement-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.problem-statement-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.problem-statement-section.content') }}
        </p>
      </div>

      <!-- Chart image -->
      <figure class="shrink-0 flex flex-col gap-3 w-full lg:w-[380px]">
        <div class="rounded-2xl border border-[var(--color-neutral-300)] dark:border-[var(--color-neutral-600)] overflow-hidden">
          <img :src="taChartSrc" alt="Feedback requests successfully answered chart" class="w-full h-auto" />
        </div>
        <figcaption class="text-xs font-normal leading-normal text-[var(--text-tertiary)] text-center">
          {{ $t('caseStudies.CS_TA.problem-statement-section.image_caption') }}
        </figcaption>
      </figure>

    </div>
  </section>
  <!-- End of Problem Statement section -->

  <!-- Discovery section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pb-16 lg:pb-24 flex flex-col gap-8">

      <!-- Header -->
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.discovery-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.discovery-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.discovery-section.content') }}
        </p>
      </div>

      <!-- Image block -->
      <div class="bg-[var(--color-neutral-100)] dark:bg-[var(--color-neutral-700)] rounded-2xl pt-4 px-4 pb-6 flex flex-col gap-6">
        <img
          :src="taFeedbackLoopSrc"
          alt="Feedback loops diagram for Talent Alchemy"
          class="rounded-lg w-full h-auto object-cover"
        />
        <p class="text-sm text-center text-[var(--color-neutral-700)] dark:text-[var(--color-neutral-400)] px-0 lg:px-12">
          {{ $t('caseStudies.CS_TA.discovery-section.image_caption') }}
        </p>
      </div>

    </div>
  </section>
  <!-- End of Discovery section -->

  <!-- User Research section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pb-16 lg:pb-24 flex flex-col gap-24">

      <!-- Header + testimonials -->
      <div class="flex flex-col gap-12">
        <div class="flex flex-col gap-6">
          <div class="flex flex-col gap-2">
            <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
              {{ $t('caseStudies.CS_TA.user-research-section.label') }}
            </span>
            <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
              {{ $t('caseStudies.CS_TA.user-research-section.title') }}
            </h2>
          </div>
          <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]"
             v-html="$t('caseStudies.CS_TA.user-research-section.intro')"></p>
        </div>

        <!-- Testimonials -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-12">
          <div
            v-for="(item, idx) in $tm('caseStudies.CS_TA.user-research-section.testimonials')"
            :key="idx"
            class="flex flex-col gap-2">
            <p class="font-switzer text-xl font-semibold italic leading-snug text-center text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
              {{ item.quote }}
            </p>
            <span class="text-sm font-normal leading-normal text-center text-[var(--color-neutral-500)]">{{ item.author }}</span>
          </div>
        </div>
      </div>

      <!-- Analysis subsection -->
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-4">
          <h3 class="font-switzer text-xl sm:text-2xl font-medium leading-snug text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.user-research-section.analysis-title') }}
          </h3>
          <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.user-research-section.analysis-content') }}
          </p>
        </div>

        <!-- Image block -->
        <div class="bg-[var(--color-neutral-100)] dark:bg-[var(--color-neutral-700)] rounded-2xl pt-4 px-4 pb-6 flex flex-col gap-6">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <img :src="taAnalysis00Src" alt="Analysis of current Talent Alchemy UI — screen 1" class="rounded-lg w-full h-auto object-cover" />
            <img :src="taAnalysis01Src" alt="Analysis of current Talent Alchemy UI — screen 2" class="rounded-lg w-full h-auto object-cover" />
          </div>
          <p class="text-sm text-center text-[var(--color-neutral-700)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.user-research-section.analysis-caption') }}
          </p>
        </div>
      </div>

    </div>
  </section>
  <!-- End of User Research section -->

  <!-- Design Sprint section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-800)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-16">

      <!-- Header -->
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.design-sprint-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.design-sprint-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]"
           v-html="$t('caseStudies.CS_TA.design-sprint-section.intro')"></p>
      </div>

      <!-- Cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          v-for="(card, idx) in $tm('caseStudies.CS_TA.design-sprint-section.cards')"
          :key="idx"
          class="rounded-2xl border border-[var(--color-neutral-300)] dark:border-[var(--color-neutral-600)] p-6 flex flex-col gap-3">
          <span class="font-switzer text-xl md:text-2xl font-bold leading-snug tracking-tight text-[var(--color-neutral-500)]">{{ card.title }}</span>
          <p class="font-switzer text-lg md:text-xl font-medium leading-snug text-[var(--color-neutral-500)]">{{ card.description }}</p>
        </div>
      </div>

    </div>
  </section>
  <!-- End of Design Sprint section -->

  <!-- Early Explorations section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-12">

      <!-- Header + image block -->
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.early-explorations-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.early-explorations-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.early-explorations-section.content') }}
        </p>

        <!-- Iterations image block -->
        <div class="bg-[var(--color-neutral-100)] dark:bg-[var(--color-neutral-700)] rounded-2xl pt-4 px-4 pb-6 flex flex-col gap-6">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <img :src="taEarlyIter00Src" alt="Home page concept — early iteration" class="rounded-lg w-full h-auto object-cover" />
            <img :src="taEarlyIter01Src" alt="Feedback requests concept — early iteration" class="rounded-lg w-full h-auto object-cover" />
          </div>
          <p class="text-sm text-center text-[var(--color-neutral-700)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.early-explorations-section.iterations-caption') }}
          </p>
        </div>
      </div>

      <!-- Testing with users subsection -->
      <div class="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">

        <!-- Left: text -->
        <div class="flex flex-col gap-4 flex-1">
          <h3 class="font-switzer text-2xl sm:text-3xl font-medium leading-snug text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.early-explorations-section.testing-title') }}
          </h3>
          <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]"
             v-html="$t('caseStudies.CS_TA.early-explorations-section.testing-intro')"></p>
          <ul class="list-disc pl-5 flex flex-col gap-1">
            <li
              v-for="(item, idx) in $tm('caseStudies.CS_TA.early-explorations-section.testing-items')"
              :key="idx"
              class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
              {{ item }}
            </li>
          </ul>
        </div>

        <!-- Right: GIF image block -->
        <div class="rounded-2xl border border-[var(--color-neutral-300)] dark:border-[var(--color-neutral-600)] pt-2 px-2 pb-4 flex flex-col gap-4 shrink-0 w-full lg:w-[680px]">
          <img :src="taEarlyExpGifSrc" alt="Exploring paths — providing feedback flow" class="rounded-lg w-full h-auto" />
          <p class="text-sm text-center text-[var(--color-neutral-700)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.early-explorations-section.testing-caption') }}
          </p>
        </div>

      </div>
    </div>
  </section>
  <!-- End of Early Explorations section -->

  <!-- Accessibility Audit section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-800)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-8">

      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.accessibility-audit-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.accessibility-audit-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.accessibility-audit-section.content') }}
        </p>
      </div>

      <!-- Image block -->
      <div class="bg-[var(--color-neutral-100)] dark:bg-[var(--color-neutral-700)] rounded-2xl pt-4 px-4 pb-6 flex flex-col gap-6">
        <imageLauncherVue
          :src="taAuditSrc"
          alt="Accessibility audit annotations for Talent Alchemy screens"
        />
        <p class="text-sm text-center text-[var(--color-neutral-700)] dark:text-[var(--color-neutral-400)]">
          {{ $t('caseStudies.CS_TA.accessibility-audit-section.image_caption') }}
        </p>
      </div>

    </div>
  </section>
  <!-- End of Accessibility Audit section -->

  <!-- New Experience section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-6">
      <div class="flex flex-col gap-2">
        <span class="text-base font-medium leading-none text-[var(--color-neutral-500)]">
          {{ $t('caseStudies.CS_TA.new-experience-section.label') }}
        </span>
        <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
          {{ $t('caseStudies.CS_TA.new-experience-section.title') }}
        </h2>
      </div>
      <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)] max-w-[840px]">
        {{ $t('caseStudies.CS_TA.new-experience-section.content') }}
      </p>
    </div>
  </section>
  <!-- End of New Experience section -->

  <!-- Report Page section -->
  <section class="bg-[var(--color-neutral-0)] dark:bg-[var(--color-neutral-900)]">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] pb-16 lg:pb-24 flex flex-col gap-32">

      <!-- Intro: image left, text right -->
      <div class="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
        <div class="w-full lg:flex-1 rounded-2xl overflow-hidden">
          <img :src="taReportPageSrc" alt="Talent Alchemy report page — feedback report screen" class="w-full h-auto" />
        </div>
        <div class="w-full lg:w-[400px] shrink-0 flex flex-col gap-5">
          <h2 class="font-switzer text-4xl lg:text-6xl font-bold leading-snug tracking-[-0.04em] text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.report-page-section.title') }}
          </h2>
          <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
            {{ $t('caseStudies.CS_TA.report-page-section.content') }}
          </p>
        </div>
      </div>



      <!-- 3-step walkthrough -->
      <div class="flex flex-col gap-16 lg:gap-24">

        <!-- Step 1: Create events (image left, text right) -->
        <div class="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div class="w-full lg:w-3/5 rounded-xl overflow-hidden">
            <img :src="taEventDetailsSrc" alt="Create events — event details form" class="w-full h-auto" />
          </div>
          <div class="w-full lg:w-2/5 flex flex-col gap-4">
            <h3 class="font-switzer text-3xl sm:text-4xl font-bold leading-tight text-[var(--text-primary)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[0].title') }}
            </h3>
            <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[0].description') }}
            </p>
          </div>
        </div>

        <!-- Step 2: Add providers (text left, image right) -->
        <div class="flex flex-col-reverse lg:flex-row items-center gap-8 lg:gap-16">
          <div class="w-full lg:w-2/5 flex flex-col gap-4">
            <h3 class="font-switzer text-3xl sm:text-4xl font-bold leading-tight text-[var(--text-primary)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[1].title') }}
            </h3>
            <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[1].description') }}
            </p>
          </div>
          <div class="w-full lg:w-3/5 rounded-xl overflow-hidden">
            <img :src="taEventProvidersSrc" alt="Add providers — feedback providers table" class="w-full h-auto" />
          </div>
        </div>

        <!-- Step 3: Track your requests (image left, text right) -->
        <div class="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div class="w-full lg:w-3/5 rounded-xl overflow-hidden">
            <img :src="taEventStatusSrc" alt="Track your requests — event status" class="w-full h-auto" />
          </div>
          <div class="w-full lg:w-2/5 flex flex-col gap-4">
            <h3 class="font-switzer text-3xl sm:text-4xl font-bold leading-tight text-[var(--text-primary)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[2].title') }}
            </h3>
            <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)]">
              {{ $t('caseStudies.CS_TA.report-page-section.steps[2].description') }}
            </p>
          </div>
        </div>

      </div>

      <!-- Final experience screen galleries -->
      <div class="flex flex-col gap-4">
        <imageLauncherVue :images="taFinalExpGallery" :startIndex="0">
          <div class="rounded-2xl overflow-hidden group">
            <img :src="taFinalExpGallery[0].src" :alt="taFinalExpGallery[0].alt" class="w-full h-auto object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
          </div>
        </imageLauncherVue>
        <imageLauncherVue :images="taFinalExpGallery" :startIndex="1">
          <div class="rounded-2xl overflow-hidden group">
            <img :src="taFinalExpGallery[1].src" :alt="taFinalExpGallery[1].alt" class="w-full h-auto object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
          </div>
        </imageLauncherVue>
      </div>

    </div>
  </section>
  <!-- End of Report Page section -->



  <!-- Impact at Scale section -->
  <section class="bg-[var(--color-neutral-50)] dark:bg-[var(--color-neutral-800)] reveal">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 lg:py-20 flex flex-col gap-12">

      <!-- Header -->
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="font-switzer text-[13px] font-medium leading-none tracking-[0.78px] uppercase text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.impact-scale-section.label') }}
          </span>
          <h2 class="font-switzer text-3xl leading-tight sm:text-4xl sm:leading-snug font-bold text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.impact-scale-section.title') }}
          </h2>
        </div>
        <p class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)] dark:text-[var(--color-neutral-400)] max-w-[840px]">
          {{ $t('caseStudies.CS_TA.impact-scale-section.description') }}
        </p>
      </div>

      <!-- Stats row -->
      <div class="grid grid-cols-2 lg:flex lg:gap-12 gap-8">
        <div
          v-for="(stat, idx) in $tm('caseStudies.CS_TA.impact-scale-section.stats')"
          :key="idx"
          class="flex flex-col gap-1">
          <span class="font-switzer text-2xl sm:text-3xl font-medium leading-snug text-[var(--text-primary)]">{{ stat.value }}</span>
          <span class="font-switzer text-lg font-normal leading-relaxed text-[var(--color-neutral-500)]">{{ stat.label }}</span>
        </div>
      </div>

    </div>
  </section>
  <!-- End of Impact at Scale section -->

  <!-- Selected work section -->
  <section class="bg-[var(--surface-bg)]">
    <div class="mx-auto max-w-6xl px-6 lg:px-[60px] py-16 flex flex-col gap-6">

      <!-- Header + divider -->
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <p class="text-xs font-medium leading-none tracking-[0.06em] uppercase text-[var(--color-neutral-500)]">
            {{ $t('caseStudies.CS_TA.selected-work-section.label') }}
          </p>
          <h3 class="text-2xl sm:text-3xl font-medium leading-snug text-[var(--text-primary)]">
            {{ $t('caseStudies.CS_TA.selected-work-section.title') }}
          </h3>
        </div>
      </div>

      <!-- Link buttons -->
      <div class="flex flex-wrap gap-8">
        <router-link
          v-for="(link, idx) in $tm('caseStudies.CS_TA.selected-work-section.links')"
          :key="idx"
          :to="{ name: link.name }"
          class="inline-flex items-center justify-center h-9 px-5 rounded-md border border-[var(--color-brand-primary)] text-[var(--color-brand-primary)] text-xs font-medium leading-none whitespace-nowrap transition-colors duration-[var(--duration-normal)] hover:bg-[var(--color-brand-primary-light)] dark:hover:bg-[var(--surface-brand)]"
        >
          {{ link.label }}
        </router-link>
      </div>

    </div>
  </section>
  <!-- End / Selected work section -->




  </div>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import imageLauncherVue from '../components/imageLauncher.vue'
import { useScrollReveal } from '../composables/useScrollReveal'

export default {
  name: "Contact-me",
  components: {
    imageLauncherVue
  },
  methods: {
    isExternal(url) {
      // crude check: external if starts with http.
      // Used to determine what type of button to use (router-link vs link) .
      return /^https?:\/\//.test(url);
    }
  },
  computed: {
    // Computed properties are cached getters, not functions.
    // so we return a function to use parameters such fileName.
    imgSrc() {
      return (urlFile) => {
        try {
          return require(`../${urlFile}`);
        } catch (e) {
          return require("../assets/img-placeholder.jpg");
        }
      }
    },

    iconSrc() {
      return (urlIcon) => {
        try {
          return require(`../${urlIcon}`);
        } catch (e) {
          return require("../assets/img-placeholder.jpg");
        }
      }
    }


  },
  setup() {
    const { t } = useI18n()
    const root = ref(null)
    useScrollReveal(root)

    const heroScreenSrc  = require('../assets/work-gallery/CS-TA/CS_TA_hero-screen.png');
    const taLogoInkSrc   = require('../assets/work-gallery/logos/TA_logo_ink.png');
    const taLogoWhiteSrc = require('../assets/work-gallery/logos/TA_logo_white.png');
    const taChartSrc        = require('../assets/work-gallery/CS-TA/CS_talent_alchemy_chart.png');
    const taFeedbackLoopSrc = require('../assets/work-gallery/CS-TA/CS_TA_feedback_loop.png');
    const taAnalysis00Src   = require('../assets/work-gallery/CS-TA/CS_TA_analysis_old_UI_00.png');
    const taAnalysis01Src   = require('../assets/work-gallery/CS-TA/CS_TA_analysis_old_UI_01.png');
    const taEarlyIter00Src  = require('../assets/work-gallery/CS-TA/CS_TA_early_iterations_00.png');
    const taEarlyIter01Src  = require('../assets/work-gallery/CS-TA/CS_TA_early_iterations_01.png');
    const taEarlyExpGifSrc  = require('../assets/work-gallery/CS-TA/CS_TA_exploration.gif');
    const taAuditSrc          = require('../assets/work-gallery/CS-TA/CS_TA_audit.png');
    const taReportPageSrc     = require('../assets/work-gallery/CS-TA/CS_TA_reportpage.png');
    const taEventDetailsSrc   = require('../assets/work-gallery/CS-TA/CS_TA_event-details.png');
    const taEventProvidersSrc = require('../assets/work-gallery/CS-TA/CS_TA_event-providers.png');
    const taEventStatusSrc    = require('../assets/work-gallery/CS-TA/CS_TA_event-status.png');
    const taFinalExpGallery   = [
      { src: require('../assets/work-gallery/CS-TA/CS_TA_finalexp_block00.png'), alt: 'Talent Alchemy final experience — screen block 01' },
      { src: require('../assets/work-gallery/CS-TA/CS_TA_finalexp_block01.png'), alt: 'Talent Alchemy final experience — screen block 02' },
    ];

    return { t, root, heroScreenSrc, taLogoInkSrc, taLogoWhiteSrc, taChartSrc, taFeedbackLoopSrc, taAnalysis00Src, taAnalysis01Src, taEarlyIter00Src, taEarlyIter01Src, taEarlyExpGifSrc, taAuditSrc, taReportPageSrc, taEventDetailsSrc, taEventProvidersSrc, taEventStatusSrc, taFinalExpGallery };
  },
};
</script>
<style scoped>
.reveal {
  opacity: 0;
  transform: translateY(44px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>

<style>

/* Hero section background gradient */
  .hero-sayhi-gradient-bg {
    background-image:
      linear-gradient(
        29.9672deg,
        rgba(255, 255, 255, 0.5) 35.838%,
        rgba(218, 254, 247, 0.5) 75.837%,
        rgba(255, 255, 255, 0.5) 135.98%
      ),
      linear-gradient(
        158.877deg,
        rgba(241, 252, 255, 0.65) 28.608%,
        rgba(133, 141, 255, 0.65) 140.47%
      );
  }

/* Tasks section border gradient */

.task-border-gradient {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid transparent;
  background-clip: padding-box;
  position: relative;
}

.task-border-gradient::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 4px;
  padding: 1px;
  background:       linear-gradient(
        29.9672deg,
        rgb(19, 200, 255) 35.838%,
        rgb(19, 255, 208) 75.837%,
        rgba(255, 255, 255, 0.5) 135.98%
      );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
</style>
